<template>
	<div class="im-chat-footer">
			<div class="send-content-shell">
				<div class="chat-tool-bar">
					<div class="toolbar-left" :class="{ 'is-disabled': inputDisabled }" :aria-disabled="inputDisabled"
						@click.capture="guardToolbarAction" @keydown.capture="guardToolbarAction">
						<div class="toolbar-group">
							<div title="表情" class="toolbar-action icon iconfont icon-emoji" ref="emotion" @click.stop="$emit('show-emotion')"></div>
							<div
								v-if="electronMode"
								title="截图(CTRL + ALT + A)"
								class="toolbar-action icon iconfont icon-screenshot"
								@click.stop="$emit('screenshot')"
							></div>
							<i
								v-if="electronMode"
								class="toolbar-action toolbar-action--compact el-icon-caret-bottom"
								@click="$emit('show-screenshot-menu', $event)"
							></i>
						</div>
						<div v-if="showAttachmentGroup" class="toolbar-divider"></div>
						<div v-if="showAttachmentGroup" class="toolbar-group">
							<div title="发送图片" v-if="chatImageMaxSize > 0" class="toolbar-action">
								<file-upload
									:action="'/image/upload'"
									:maxSize="chatImageMaxSize"
									:before-check="checkUploadAllowed"
									:disabled="inputDisabled"
									:fileTypes="['image/jpeg', 'image/png', 'image/jpg', 'image/webp', 'image/gif']"
									@before="onImageBefore"
									@success="onImageSuccess"
									@fail="onImageFail"
								>
									<i class="toolbar-action__glyph el-icon-picture-outline"></i>
								</file-upload>
							</div>
							<div title="发送视频" v-if="chatVideoMaxSize > 0" class="toolbar-action">
								<file-upload
									ref="videoUpload"
									:action="'/video/upload'"
									:maxSize="chatVideoMaxSize"
									:before-check="checkUploadAllowed"
									:disabled="inputDisabled"
									:fileTypes="['video/mp4', 'video/ogg', 'video/webm', 'video/quicktime']"
									@before="onVideoBefore"
									@success="onVideoSuccess"
									@fail="onVideoFail"
								>
									<i class="toolbar-action__glyph el-icon-film"></i>
								</file-upload>
							</div>
							<div title="发送文件" v-if="chatFileMaxSize > 0" class="toolbar-action">
								<file-upload
									ref="fileUpload"
									:action="'/file/upload'"
									:maxSize="chatFileMaxSize"
									:before-check="checkUploadAllowed"
									:disabled="inputDisabled"
									@before="onFileBefore"
									@success="onFileSuccess"
									@fail="onFileFail"
								>
									<i class="toolbar-action__glyph el-icon-paperclip"></i>
								</file-upload>
							</div>
						</div>
						<div v-if="showUtilityGroup" class="toolbar-divider"></div>
						<div v-if="showUtilityGroup" class="toolbar-group">
							<div
								v-if="isGroup"
								title="回执消息"
								class="toolbar-action icon iconfont icon-receipt"
								:class="isReceipt ? 'chat-tool-active' : ''"
								@click="$emit('toggle-receipt')"
							></div>
							<div
								v-if="chatAudioMaxSize > 0"
								title="发送语音"
								class="toolbar-action"
								@click="$emit('show-record')"
							>
								<i class="toolbar-action__glyph el-icon-microphone"></i>
							</div>
						</div>
					</div>
					<div class="toolbar-send-btn">
						<el-button type="primary" icon="el-icon-s-promotion" :disabled="inputDisabled" @click="$emit('send')">发送</el-button>
				</div>
			</div>
			<div class="send-content-area">
				<div v-if="quoteMessage" class="quote-message">
					<chat-quote-message :showName="quoteShowName" :msgInfo="quoteMessage"></chat-quote-message>
					<div class="quote-remove" @click="$emit('clear-quote')">
						<i class="el-icon-close"></i>
					</div>
				</div>
				<div class="chat-input-wrapper">
					<chat-input
						ref="chatInputEditor"
						:group="group"
						:group-members="groupMembers"
						:placeholder="placeholder"
						:disabled="inputDisabled"
						@submit="$emit('submit', $event)"
					/>
					<div class="chat-editer-mask" v-if="inputDisabled" role="status">
						<span class="icon el-icon-warning" aria-hidden="true"></span>
						<span class="chat-editer-tip">{{ notAllowInputTip }}</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import FileUpload from "../common/FileUpload.vue";
import ChatInput from "./ChatInput.vue";
import ChatQuoteMessage from "./ChatQuoteMessage.vue";

export default {
	name: "chatFooter",
	components: {
		FileUpload,
		ChatInput,
		ChatQuoteMessage
	},
	props: {
		beforeCheck: {
			type: Function,
			default: null
		},
		group: {
			type: Object,
			default: () => ({})
		},
		groupMembers: {
			type: Array,
			default: () => []
		},
		isGroup: {
			type: Boolean,
			default: false
		},
		isMobile: {
			type: Boolean,
			default: false
		},
		isPrivate: {
			type: Boolean,
			default: false
		},
		isReceipt: {
			type: Boolean,
			default: false
		},
		placeholder: {
			type: String,
			default: "聊点什么吧~"
		},
		quoteMessage: {
			type: Object,
			default: null
		},
		quoteShowName: {
			type: String,
			default: ""
		},
		notAllowInputTip: {
			type: String,
			default: ""
		},
		chatImageMaxSize: {
			type: Number,
			default: 0
		},
		chatFileMaxSize: {
			type: Number,
			default: 0
		},
		chatVideoMaxSize: {
			type: Number,
			default: 0
		},
		chatAudioMaxSize: {
			type: Number,
			default: 0
		},
		electronMode: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		inputDisabled() {
			return Boolean(this.notAllowInputTip);
		},
		showAttachmentGroup() {
			return this.chatImageMaxSize > 0 || this.chatVideoMaxSize > 0 || this.chatFileMaxSize > 0;
		},
		showUtilityGroup() {
			return this.isGroup || this.chatAudioMaxSize > 0;
		}
	},
	methods: {
		guardToolbarAction(event) {
			if (this.inputDisabled) {
				event.preventDefault();
				event.stopPropagation();
			}
		},
		checkUploadAllowed(file) {
			return !this.inputDisabled && (!this.beforeCheck || this.beforeCheck(file) !== false);
		},
		onImageBefore(file) {
			this.$emit('image-before', file);
		},
		onImageSuccess(data, file, upload) {
			this.$emit('image-success', data, upload || file);
		},
		onImageFail(error, file, upload) {
			this.$emit('image-fail', error, upload || file);
		},
		onFileBefore(file) {
			this.$emit('file-before', file);
		},
		onFileSuccess(url, file, upload) {
			this.$emit('file-success', url, upload || file);
		},
		onFileFail(error, file, upload) {
			this.$emit('file-fail', error, upload || file);
		},
		onVideoBefore(file) {
			this.$emit('video-before', file);
		},
		onVideoSuccess(data, file, upload) {
			this.$emit('video-success', data, upload || file);
		},
		onVideoFail(error, file, upload) {
			this.$emit('video-fail', error, upload || file);
		},
		getEmotionTrigger() {
			return this.$refs.emotion || null;
		},
		focusInput() {
			if (this.$refs.chatInputEditor) {
				this.$refs.chatInputEditor.focus();
			}
		},
		clearInput() {
			if (this.$refs.chatInputEditor) {
				this.$refs.chatInputEditor.clear();
			}
		},
		submitInput() {
			if (this.$refs.chatInputEditor) {
				this.$refs.chatInputEditor.submit();
			}
		},
		insertEmoji(emojiText) {
			if (this.$refs.chatInputEditor) {
				this.$refs.chatInputEditor.insertEmoji(emojiText);
			}
		},
		pasteScreenShot(buffer) {
			if (this.$refs.chatInputEditor) {
				this.$refs.chatInputEditor.pasteScreenShot(buffer);
			}
		},
		saveDraft(chat) {
			if (this.$refs.chatInputEditor) {
				this.$refs.chatInputEditor.saveDraft(chat);
			}
		},
		restoreDraft(chat) {
			if (this.$refs.chatInputEditor) {
				this.$refs.chatInputEditor.restoreDraft(chat);
			}
		},
		uploadFile(file) {
			if (this.inputDisabled) return false;
			const fileUpload = this.$refs.fileUpload;
			if (!fileUpload) {
				return false;
			}
			const passed = fileUpload.beforeUpload(file);
			if (passed) {
				fileUpload.onFileUpload({ file });
			}
			return passed;
		},
		uploadVideo(file) {
			if (this.inputDisabled) return false;
			const videoUpload = this.$refs.videoUpload;
			if (!videoUpload) {
				return false;
			}
			const passed = videoUpload.beforeUpload(file);
			if (passed) {
				videoUpload.onFileUpload({ file });
			}
			return passed;
		}
	}
}
</script>

<style scoped lang="scss">
.im-chat-footer {
	position: relative;
	display: flex;
	flex-direction: column;
	flex-shrink: 0;
	min-height: 0;
	max-height: none;
	padding: 0 12px 12px;
	background: var(--im-chat-bg);
	border-top: 1px solid var(--im-surface-panel-border);

	.send-content-shell {
		position: relative;
		display: flex;
		flex-direction: column;
		flex: none;
		min-height: 0;
		overflow: hidden;
		border-radius: 0;
		background: transparent;
	}

	.chat-tool-bar {
		display: flex;
		position: relative;
		width: 100%;
		min-height: 44px;
		text-align: left;
		box-sizing: border-box;
		padding: 6px 0 8px;
		align-items: center;
		justify-content: space-between;
		color: var(--im-icon-color);
		gap: 9px;
		border-bottom: 1px solid rgba(var(--im-black-rgb), 0.05);

		.toolbar-left {
			display: flex;
			align-items: center;
			gap: 9px;
			flex: 1;
			min-width: 0;
			flex-wrap: wrap;

			&.is-disabled {
				opacity: 0.5;
				cursor: not-allowed;

				.toolbar-action {
					cursor: not-allowed;
					pointer-events: none;
				}
			}
		}

		.toolbar-group {
			display: inline-flex;
			align-items: center;
			gap: 6px;
			min-width: 0;
			padding: 0;
			border-radius: 0;
			background: transparent;
		}

		.toolbar-divider {
			width: 1px;
			height: 16px;
			align-self: center;
			background: rgba(var(--im-black-rgb), 0.07);
			border-radius: 0;
			flex-shrink: 0;
		}

		.toolbar-send-btn {
			flex-shrink: 0;
			margin-left: auto;

			::v-deep .el-button {
				border-radius: 7px;
				height: 33px;
				min-width: 80px;
				padding: 0 16px;
				font-size: 13px;
				font-weight: 600;
				box-shadow: none;
			}
		}

		.toolbar-action {
			font-size: 16px;
			cursor: pointer;
			width: 32px;
			height: 32px;
			line-height: 32px;
			text-align: center;
			border-radius: 8px;
			transition: color 0.2s ease, background 0.2s ease, border-color 0.2s ease;
			display: flex;
			align-items: center;
			justify-content: center;
			position: relative;
			flex-shrink: 0;

			&.chat-tool-active {
				color: var(--im-icon-hover-color);
				background: var(--im-icon-active-bg);
			}

			&:hover {
				color: var(--im-icon-hover-color);
				background: var(--im-icon-hover-bg);
			}

			:deep(.el-upload) {
				display: flex;
				align-items: center;
				justify-content: center;
				width: 100%;
				height: 100%;
				color: inherit;
			}
		}

		.toolbar-action__glyph {
			display: inline-flex;
			align-items: center;
			justify-content: center;
			font-size: 15px;
			line-height: 1;
			transform: translateY(0);
		}

		.toolbar-action--compact {
			font-size: 12px;
			width: 24px;
			height: 24px;
			line-height: 24px;
		}
	}

	.send-content-area {
		display: flex;
		flex-direction: column;
		flex: none;
		min-height: 0;
		background: transparent;
		padding: 8px 0 0;
		gap: 6px;

		.quote-message {
			display: flex;
			align-items: center;
			gap: 6px;
			min-width: 0;
			font-size: 14px;
			padding: 0;
			border: none;
			background: transparent;

			::v-deep .chat-quote-message {
				flex: 1;
				min-width: 0;
				padding: 6px 8px;
				gap: 6px;
				border-radius: 8px;
				border: 1px solid rgba(var(--im-primary-rgb), 0.07);
				background: rgba(var(--im-primary-rgb), 0.035);
			}

			::v-deep .chat-quote-message .send-user {
				font-size: 12px;
				font-weight: 600;
				color: var(--im-text-color-secondary);
			}

			::v-deep .chat-quote-message .quote-text {
				line-height: 18px;
			}

			.quote-remove {
				display: inline-flex;
				align-items: center;
				justify-content: center;
				flex-shrink: 0;
				width: 22px;
				height: 22px;
				line-height: 22px;
				font-size: 12px;
				color: var(--im-text-color-light);
				border-radius: 7px;
				border: 1px solid rgba(var(--im-black-rgb), 0.06);
				background: rgba(var(--im-black-rgb), 0.02);
				cursor: pointer;
				transition: color 0.2s ease, background-color 0.2s ease, border-color 0.2s ease;

				&:hover {
					color: var(--im-icon-hover-color);
					background: rgba(var(--im-primary-rgb), 0.06);
					border-color: rgba(var(--im-primary-rgb), 0.1);
				}
			}
		}
	}

	::v-deep .chat-input-area {
		flex: none;
		--chat-editor-min-height: 72px;
		--chat-editor-max-height: 228px;
		min-height: calc(var(--chat-editor-min-height) + 18px);
		max-height: calc(var(--chat-editor-max-height) + 18px);
		height: auto;
	}

	.chat-input-wrapper {
		position: relative;
		min-width: 0;
		border-radius: 10px;
	}

	.chat-editer-mask {
		position: absolute;
		inset: 0;
		z-index: 1;
		box-sizing: border-box;
		padding: 12px;
		gap: 4px;
		background: var(--im-chat-bg-alt);
		font-size: var(--im-font-size-large);
		color: var(--im-text-color-light);
		display: flex;
		justify-content: center;
		align-items: center;
		text-align: center;
		border-radius: inherit;
		border: 1px solid var(--im-surface-panel-border);
		cursor: not-allowed;

		.icon {
			font-size: var(--im-font-size-larger);
			flex-shrink: 0;
		}

		.chat-editer-tip {
			min-width: 0;
			overflow-wrap: anywhere;
		}
	}
}

@media (max-width: 640px) {
	.im-chat-footer {
		min-height: 0;
		padding: 0 10px calc(8px + env(safe-area-inset-bottom));

		.chat-tool-bar {
			align-items: center;
			flex-wrap: nowrap;
			gap: 8px;

			.toolbar-left {
				width: auto;
				flex-wrap: nowrap;
				overflow-x: auto;
				overflow-y: hidden;
				scrollbar-width: none;
				-webkit-overflow-scrolling: touch;

				&::-webkit-scrollbar {
					display: none;
				}
			}

			.toolbar-group {
				flex-shrink: 0;
			}

			.toolbar-send-btn {
				width: auto;
				display: flex;
				justify-content: flex-end;
				margin-left: auto;
				flex-shrink: 0;
			}
		}

		::v-deep .chat-input-area {
			flex-basis: auto;
			--chat-editor-min-height: 58px;
			--chat-editor-max-height: 172px;
			min-height: calc(var(--chat-editor-min-height) + 16px);
			max-height: calc(var(--chat-editor-max-height) + 16px);
			height: auto;
		}
	}
}
</style>
